import {JourneyTrack} from '../journey-track';
import {TrackInfo} from '../model/track-info';
import {TrackTypes} from '../model/track-types';
import {DomainOrigin} from "../../../domains/model/domain-origin";
import {TrackActionResult} from "../model/track-action-result";
import {DataOrigin} from "../../../../model/DataOrigin";
import {environment} from "../../../../../../environments/environment";
import {ContaIonDataParse} from "./util/conta-ion-data-parse";
import {OriginIncomeAction} from "./actions/origin-income-action";
import {ProfessionalAction} from "./actions/professional-action";
import {CacheService} from "../../../comunicator-native/cache/v2/cache.service";
import { MobileMockData } from './util/mobile-mock-data';
import { Platform } from '@ionic/angular';

export class ContaIonProfessionalTrack extends JourneyTrack {

    readonly originalTracks = [

        new TrackInfo('pep', ['professional-data', 'pep']),

        new TrackInfo('origin-income', ['professional-data', 'origin-income'],
            undefined, {domainOrigin: DomainOrigin[environment.contaIonDomainOrigin], 
                actionName: ActionList.OriginIncome}),
        
        new TrackInfo('profession', ['professional-data', 'profession'],
            undefined, {domainOrigin: DomainOrigin[environment.contaIonDomainOrigin], 
                actionName: ActionList.Profession}),

        new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj'],
            undefined, {dataOrigin: DataOrigin[environment.contaIonDataOrigin]}),
 
    ];

    track = [];

    constructor(private cacheNativeService: CacheService, private platform: Platform) {
        super();
        this.track = this.originalTracks;
    }

    getName(): TrackTypes {
        return TrackTypes.CONTA_ION_PROFESSIONAL;
    }

    getTrack(): TrackInfo[] {
        return this.track;
    }

    public async loadData() {
        //MobileMockData.executeMockCall(500);
        const data = await this.cacheNativeService.getItemCommunicator();
        return Promise.resolve(ContaIonDataParse.parseFromMobileData(data));
    }

    public isUncoupled() {
        return true;
    }

    public executeAction(actionName, data): TrackActionResult {

        switch (actionName) {
            case ActionList.OriginIncome:
                return OriginIncomeAction.execute(data, this.track, this.originalTracks)
            case ActionList.Profession:
                return ProfessionalAction.execute(data, this.track, this.originalTracks)
        }

    }

    isEventComunicator() {
        return true;
    }

    isBackHeader() {
        return this.platform.is('android');
    }

}

export enum ActionList{
    OriginIncome = 'origin',
    Profession = 'profession',
}